import { RCL as useTranslation } from "../../components/RCL";

export function useNotificationLabels() {
	return {
		a11yToggleNotifications: useTranslation({ searchKey: "a11y-notifications-toggle" }),
		a11yCloseMenu: useTranslation({ searchKey: "a11y-close-notifications-menu" }),
		a11yOpenLiveRegion: useTranslation({ searchKey: "a11y-open-notifications-live-region" }),
		a11yClosedLiveRegion: useTranslation({ searchKey: "a11y-closed-notifications-live-region" }),
		a11yMenu: useTranslation({ searchKey: "a11y-notifications-menu" }),
		a11yList: useTranslation({ searchKey: "a11y-notifications-list" }),
		noResultsAll: useTranslation({ searchKey: "notifications-filter-no-results-all" }),
		noResultsAlert: useTranslation({ searchKey: "notifications-filter-no-results-alert" }),
		noResultsOffer: useTranslation({ searchKey: "notifications-filter-no-results-offer" }),
		menuHeadingAll: useTranslation({ searchKey: "notifications-filter-type-heading-all" }),
		menuHeadingAlert: useTranslation({ searchKey: "notifications-filter-type-heading-alert" }),
		menuHeadingOffer: useTranslation({ searchKey: "notifications-filter-type-heading-offer" }),
		menuTitleAll: useTranslation({ searchKey: "notifications-filter-title-all" }),
		menuTitleAlert: useTranslation({ searchKey: "notifications-filter-title-alert" }),
		menuTitleOffer: useTranslation({ searchKey: "notifications-filter-title-offer" }),
		menuViewAlert: useTranslation({ searchKey: "notifications-filter-title-alert" }),
		menuViewOffer: useTranslation({ searchKey: "notifications-filter-title-offer" }),
	};
}
